import { useQuery } from '@apollo/client/react';
import { PassPurchaseForm } from '@drycut/booking-components';
import { type BasicPassFragment, GetPassDocument, type Maybe } from '@drycut/graphql';
import { Loader } from '@drycut/ui-components';
import { useNavigate, useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function NewPassPurchase(): React.ReactNode {
  useDocumentTitle('DRYCUT - DRYPASS');

  const { passId } = useParams() as { passId: string };
  const { data, loading } = useQuery(GetPassDocument, { variables: { passId } });
  const navigate = useNavigate();

  const pass: Maybe<BasicPassFragment> = data?.pass || null;

  if (loading) {
    return <Loader />;
  }

  if (!pass) {
    navigate('/not-found');
    return null;
  }

  return <PassPurchaseForm pass={pass} />;
}
